// angular
import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
// types & interfaces
import { AccordionData } from '@app/shared/types/accordion-data.type';
import { II18n } from '@app/shared/interfaces/i18n.interface';
// pipe
import { TranslateDataPipe } from '@app/shared/pipes/translate-data.pipe';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'pwj-accordion',
  standalone: true,
  imports: [CommonModule, TranslateModule, TranslateDataPipe, RouterLink],
  templateUrl: './accordion.component.html',
  styleUrl: './accordion.component.scss',
})
export class AccordionComponent {
  public activeItem!: string | null;

  // inputs
  accordionData = input.required<AccordionData[]>();

  public openAccordionItem(id: string) {
    if (this.activeItem === id) {
      this.activeItem = null;
    } else {
      this.activeItem = id;
    }
  }

  public isString(item: string | II18n) {
    return typeof item === 'string';
  }
}
